exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f1818cd2] .el-table{font-size:13px}[data-v-f1818cd2] .el-table .cell{line-height:14px}", ""]);

// exports
